// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchForm_root__laXYI","icon":"SearchForm_icon__grKNG","input":"SearchForm_input___uist"};